import {SensorReading} from "../entities/SensorReadingHistory";
import {BaseService} from "./BaseService";
import { StateService } from "@uirouter/angularjs";

export class SensorService extends BaseService<SensorReading>{
        static $inject = ['$http','$q','$state'];
        constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
            super($http, $q, $state, SensorReading);
        }
        protected getBaseUrl():string{
            return "sensorreading";
        }
        getByVTagId(vtagId:string):ng.IPromise<SensorReading[]>{
            var config:any = {};
            return this.useBaseGetArrayHandler(this.getBasesUrl(),"VTag/"+vtagId, config);
        }
        getLastByAssetId(assetId:number){
            var config:any = {};
            return this.useBaseGetHandler(this.getBaseUrl(),"last/"+assetId, config);
        }
        getReport(vtagPositionType:string, days:number){
            var config:any = {
                headers: {
                    'Content-type': 'application/json',
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                },
                responseType: 'arraybuffer'
            };
            return this.useGetHandler("Report","VTagCommunications?vTagPositionType="+vtagPositionType+"&days="+days, config);
        }
        getHistoryCounts(vtagPositionType:string, days:number){
            var config:any = {};
            return this.useGetHandler(this.getBasesUrl(),"HistoryCounts?vtagPositionType="+vtagPositionType+"&days="+days, config);
        }
        getHistoryCountCounts(vtagPositionType:string, days:number){
            var config:any = {};
            return this.useGetHandler(this.getBasesUrl(),"HistoryCountCounts?vtagPositionType="+vtagPositionType+"&days="+days, config);
        }
    }
